<template>
  <div class="container">
    <my-header></my-header>
    <news></news>
    <div class="slot-img"></div>
    <exposure></exposure>
<!--    <info-search></info-search>-->
    <member></member>
    <links></links>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHeader from '@/components/Header'
import MyFooter from '@/components/Footer'
import News from './components/News'
import Exposure from './components/Exposure'
import InfoSearch from './components/InfoSearch'
import Member from './components/Member'
import Links from './components/Link'

export default {
  components: {
    MyHeader,
    MyFooter,
    News,
    Exposure,
    InfoSearch,
    Member,
    Links,
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
.slot-img {
  width: 1200px;
  height: 180px;
  background-image: url("../../assets/img/hft.png");
  background-size: cover;
  background-position: center center;
  margin: 50px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue